<div class="split-screen-container" [class.logged-out]="!user" [class.yerine-giris]="yerineGirisMi">

    <!-- LOADING STATE -->
    <div *ngIf="loading" class="loading-overlay">
        <div class="loading-spinner"></div>
        <p>{{ 'anasayfa.basvurularYukleniyor' | transloco }}</p>
    </div>

    <div class="split-wrapper" *ngIf="!loading" [class.selecting]="!selectedCategory"
        [class.show-turkiye]="selectedCategory === 'turkiye'" [class.show-yurtdisi]="selectedCategory === 'yurtdisi'">

        <!-- HEADER AREA CONTAINER (Master Layer) -->
        <div class="split-screen-top">
            <!-- TOP-LEFT BRANDING -->
            <div class="top-left-branding" [routerLink]="['/']">
                <div class="branding-logo">
                    <img src="/assets/img/logo.svg" [alt]=" 'giris.anadoluUni' | transloco ">
                </div>
                <div class="branding-text">
                    <span class="uni-name">{{ 'giris.anadoluUniUpper' | transloco }}</span>
                    <span class="sys-name">{{ 'giris.otomasyon' | transloco }}</span>
                </div>
            </div>

            <!-- CENTERED HEADER WRAPPER (Handles Global Placement & Center Logic) -->
            <!-- CENTERED HEADER WRAPPER: Logged In -->
            <div *ngIf="user" class="floating-header-wrapper" [class.is-long-name]="isLongName">
                <!-- THE ACTUAL STYLED HEADER -->
                <div class="floating-header">
                    <!-- WELCOME SECTION -->
                    <div class="header-section">
                        <div class="header-content">
                            <h1 class="welcome-title">
                                <span class="welcome-label">{{ 'anasayfa.hosgeldiniz' | transloco }}</span>
                                <div class="name-wrapper">
                                    <a [routerLink]="['/aday/profil/nufus']" class="welcome-name">{{ user.firstName }}
                                        {{ user.lastName }}</a>
                                    <i class="fas fa-pen edit-small" [routerLink]="['/aday/profil/nufus']"></i>
                                </div>
                            </h1>
                        </div>
                    </div>

                    <div class="header-divider"></div>

                    <!-- NAV LINKS -->
                    <div class="header-section nav-links">
                        <a [routerLink]="['/aday/gecmis-basvurular']" class="nav-item">
                            <i class="fas fa-history"></i>
                            <span>{{ 'header.gecmisBasvurular' | transloco }}</span>
                        </a>
                        <a *ngIf="user && adminMi" href="javascript:void(0)" (click)="modalGoruntule = true"
                            class="nav-item">
                            <i class="fas fa-user-cog"></i>
                            <span>{{ 'header.ogrenciSecimi' | transloco }}</span>
                        </a>
                        <a href="javascript:void(0)" (click)="logout()" class="nav-item">
                            <i class="fas fa-sign-out-alt"></i>
                            <span>{{ 'header.cikis' | transloco }}</span>
                        </a>
                    </div>
                </div>

                <!-- ACTIVE CANDIDATE CHIP (Follows the wrapper) -->
                <div class="active-candidate-chip" *ngIf="yerineGirisMi">
                    <i class="fas fa-user-edit"></i>
                    <div class="chip-content">
                        <span class="chip-label">{{ 'master.islemYapilanAday' | transloco }}</span>
                        <span class="chip-value">{{ adayBilgi }}</span>
                    </div>
                </div>
            </div>

            <!-- CENTERED HEADER WRAPPER: Logged Out CTA -->
            <div *ngIf="!user" class="floating-header-wrapper guest-mode">
                <div class="floating-header" (click)="login()">
                    <div class="header-section cta-section">
                        <div class="cta-icon">
                            <i class="fas fa-info-circle"></i>
                        </div>
                        <div class="cta-content">
                            <p class="cta-text">{{ 'anasayfa.girisMesaji' | transloco }}</p>
                        </div>
                        <div class="header-divider"></div>
                        <div class="cta-action">
                            <span>{{ 'anasayfa.girisYap' | transloco }}</span>
                            <i class="fas fa-arrow-right"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- TOP-RIGHT ACTIONS (Lang & User) -->
            <div class="top-right-actions">
                <div class="lang-selector">


                    <button class="lang-btn" [class.active]="currentLang === 'tr'" (click)="setLang('tr')">TR</button>
                    <button class="lang-btn" [class.active]="currentLang === 'en'" (click)="setLang('en')">EN</button>
                </div>
            </div>
        </div>
        <!-- SELECTION OVERLAY (Initial State) — Full-Screen Split Hero -->
        <div class="selection-overlay" *ngIf="!selectedCategory">

            <!-- LEFT HERO: TÜRKİYE -->
            <div class="hero-panel hero-turkiye" (click)="selectCategory('turkiye')">
                <!-- Dekoratif daire halkalar -->
                <div class="hero-ring hero-ring-1"></div>
                <div class="hero-ring hero-ring-2"></div>
                <div class="hero-ring hero-ring-3"></div>
                <!-- İçerik -->
                <div class="hero-content">
                    <div class="hero-badge">
                        <i class="fas fa-map-marker-alt"></i>
                    </div>
                    <h2 class="hero-title">{{ 'anasayfa.turkiyeBasvurulari' | transloco }}</h2>
                    <p class="hero-subtitle">{{ 'anasayfa.turkiyeAciklama' | transloco }}</p>
                    <div class="hero-cta">
                        <span>{{ 'anasayfa.basvuruYap' | transloco }}</span>
                        <i class="fas fa-arrow-right"></i>
                    </div>
                </div>
            </div>

            <!-- RIGHT HERO: YURTDIŞI -->
            <div class="hero-panel hero-yurtdisi" (click)="selectCategory('yurtdisi')">
                <!-- Dekoratif daire halkalar -->
                <div class="hero-ring hero-ring-1"></div>
                <div class="hero-ring hero-ring-2"></div>
                <div class="hero-ring hero-ring-3"></div>
                <!-- İçerik -->
                <div class="hero-content">
                    <div class="hero-badge">
                        <i class="fas fa-globe"></i>
                    </div>
                    <h2 class="hero-title">{{ 'anasayfa.yurtdisiBasvurulari' | transloco }}</h2>
                    <p class="hero-subtitle">{{ 'anasayfa.yurtdisiAciklama' | transloco }}</p>
                    <div class="hero-cta">
                        <span>{{ 'anasayfa.basvuruYap' | transloco }}</span>
                        <i class="fas fa-arrow-right"></i>
                    </div>
                </div>
            </div>

        </div>

        <!-- LEFT PANEL: TÜRKİYE -->
        <div class="split-panel turkiye" [class.hidden]="selectedCategory === 'yurtdisi'">
            <div class="panel-inner" *ngIf="selectedCategory === 'turkiye' || !selectedCategory">
                <!-- BACK BUTTON (Only visible when active) -->
                <div class="back-nav" *ngIf="selectedCategory === 'turkiye'" (click)="selectCategory(null)">
                    <i class="fas fa-arrow-left"></i> <span>Geri Dön</span>
                </div>

                <div class="panel-header" *ngIf="selectedCategory === 'turkiye'">
                    <div class="panel-icon"><i class="fas fa-map-marker-alt"></i></div>
                    <h2 class="panel-title">{{ 'anasayfa.turkiyeBasvurulari' | transloco }}</h2>
                    <!-- Başlık altı uyarı mesajı (Genel başvurular kapalı ancak özel kartlar varsa) -->
                    <div class="empty-state" *ngIf="!basvuruVarMi && turkiyeKartlar.length > 0">
                        <i class="fas fa-info-circle"></i>
                        <p>{{ 'anasayfa.turkiyeKapali' | transloco }}</p>
                    </div>
                </div>

                <div class="cards-grid" *ngIf="selectedCategory === 'turkiye'">

                    <div class="application-card" *ngFor="let kart of turkiyeKartlar">
                        <!-- FEATURED RIBBON -->
                        <div class="featured-ribbon" *ngIf="kart.kayitTuru">
                            <span>{{ kart.kayitTuru }}</span>
                        </div>

                        <div class="card-bg-image"
                            [style.backgroundImage]="'url(' + (kart.arkaPlanResimUrl.startsWith('http') || kart.arkaPlanResimUrl.startsWith('/') ? '' : '/assets/img/') + kart.arkaPlanResimUrl + ')'"
                            *ngIf="kart.arkaPlanResimUrl"></div>
                        <a href="javascript:void(0)" (click)="basvuruYonlendir(kart.basvuruLink)"
                            class="card-overlay-link"></a>

                        <div class="card-main">
                            <div class="card-icon"><i [class]="kart.iconClass"></i></div>
                            <div class="card-info">
                                <h3 class="card-title">{{ kart.basvuruAdi }}</h3>
                                <div class="card-date" *ngIf="kart.tarihKontroluVarMi">
                                    <i class="far fa-calendar-alt"></i> {{ kart.tarihAraligi }}
                                </div>
                            </div>
                        </div>
                        <p class="card-desc" [innerHTML]="kart.aciklama | safeHtml"></p>
                        <div class="card-links" *ngIf="kart.linkler?.length">
                            <a *ngFor="let link of kart.linkler" href="javascript:void(0)"
                                (click)="basvuruYonlendir(link.url)" class="mini-action">
                                <i [class]="link.iconClass"></i><span> {{ link.baslik }}</span>
                            </a>
                        </div>
                    </div>

                    <!-- Liste tamamen boşsa -->
                    <div class="empty-state" *ngIf="turkiyeKartlar.length === 0">
                        <i class="fas fa-info-circle"></i>
                        <p>{{ 'anasayfa.turkiyeKapali' | transloco }}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- RIGHT PANEL: YURTDIŞI -->
        <div class="split-panel yurtdisi" [class.hidden]="selectedCategory === 'turkiye'">
            <div class="panel-depth-shadow" *ngIf="!selectedCategory"></div>
            <div class="panel-inner" *ngIf="selectedCategory === 'yurtdisi' || !selectedCategory">
                <!-- BACK BUTTON -->
                <div class="back-nav" *ngIf="selectedCategory === 'yurtdisi'" (click)="selectCategory(null)">
                    <i class="fas fa-arrow-left"></i> <span>Geri Dön</span>
                </div>

                <div class="panel-header" *ngIf="selectedCategory === 'yurtdisi'">
                    <div class="panel-icon"><i class="fas fa-globe"></i></div>
                    <h2 class="panel-title">{{ 'anasayfa.yurtdisiBasvurulari' | transloco }}</h2>
                </div>

                <!-- GLOBAL WELCOME BANNER (Only when not logged in) -->
                <div class="global-onboarding-banner" *ngIf="selectedCategory === 'yurtdisi' && !user && yurtdisiKartlar.length">
                    <div class="banner-icon-wrapper">
                        <i class="fas fa-question-circle"></i>
                    </div>
                    <div class="banner-text-wrapper">
                        <h4 class="banner-title">{{ 'anasayfa.ilkDefaMiGeliyorsunuzTitle' | transloco }}</h4>
                        <p class="banner-description" [innerHTML]="'anasayfa.ilkDefaMiGeliyorsunuzDesc' | transloco">
                        </p>
                    </div>
                </div>

                <div class="cards-grid" *ngIf="selectedCategory === 'yurtdisi'">
                    <div class="application-card" [class.blue-toned]="kart.kayitTuru && (kart.kayitTuru.toLowerCase().includes('ön') || kart.kayitTuru.toLowerCase().includes('pre'))" *ngFor="let kart of yurtdisiKartlar">
                        <!-- FEATURED RIBBON -->
                        <div class="featured-ribbon" *ngIf="kart.kayitTuru">
                            <span>{{ kart.kayitTuru }}</span>
                        </div>

                        <div class="card-bg-image"
                            [style.backgroundImage]="'url(' + (kart.arkaPlanResimUrl.startsWith('http') || kart.arkaPlanResimUrl.startsWith('/') ? '' : '/assets/img/') + kart.arkaPlanResimUrl + ')'"
                            *ngIf="kart.arkaPlanResimUrl"></div>

                        <!-- Overlay only when logged in so that it doesn't block card buttons for guest users -->
                        <a *ngIf="user" href="javascript:void(0)" (click)="basvuruYonlendir(kart.basvuruLink)"
                            class="card-overlay-link"></a>

                        <div class="card-main">
                            <div class="card-icon"><i [class]="kart.iconClass"></i></div>
                            <div class="card-info">
                                <h3 class="card-title">{{ kart.basvuruAdi }}</h3>
                                <div class="card-date" *ngIf="kart.tarihKontroluVarMi">
                                    <i class="far fa-calendar-alt"></i> {{ kart.tarihAraligi }}
                                </div>
                            </div>
                        </div>
                        <p class="card-desc" [innerHTML]="kart.aciklama | safeHtml"></p>

                        <!-- Dynamic CTAs based on login state -->
                        <div class="card-buttons-container" [class.single-right-btn]="!kart.yeniHesapOlusturButonuAktifMi" *ngIf="!user">
                            <thm-button *ngIf="kart.yeniHesapOlusturButonuAktifMi" buttonType="secondary" iconClass="fas fa-user-plus"
                                (clicked)="ilkKayitYonlendir(kart.basvuruLink)">
                                {{ 'anasayfa.ilkKayit' | transloco }}
                            </thm-button>
                            <thm-button buttonType="primary" iconClass="fas fa-sign-in-alt"
                                (clicked)="basvuruYonlendir(kart.basvuruLink)">
                                {{ 'anasayfa.girisYapSecenegi' | transloco }}
                            </thm-button>
                        </div>
                        <div class="card-buttons-container single-btn" *ngIf="user">
                            <thm-button buttonType="primary" iconClass="fas fa-arrow-right"
                                (clicked)="basvuruYonlendir(kart.basvuruLink)">
                                {{ 'anasayfa.basvuruYap' | transloco }}
                            </thm-button>
                        </div>

                        <div class="card-links" *ngIf="kart.linkler?.length">
                            <a *ngFor="let link of kart.linkler" href="javascript:void(0)"
                                (click)="basvuruYonlendir(link.url)" class="mini-action">
                                <i [class]="link.iconClass"></i><span> {{ link.baslik }}</span>
                            </a>
                        </div>
                    </div>

                    <div class="empty-state" *ngIf="!yurtdisiKartlar.length">
                        <i class="fas fa-info-circle"></i>
                        <p>{{ 'anasayfa.yurtdisiKapali' | transloco }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <thm-modal [(visible)]="modalGoruntule" [maxWidth]="500" [title]="'header.ogrenciSecimi' | transloco">
        <aof-ogrenci-secim [islemYapilacakModul]="moduller.YeniBasvuru" (close)="modalKapat()">
        </aof-ogrenci-secim>
    </thm-modal>
</div>